import { z } from 'zod';

/** Deliberately no arbitrary text or URLs: these records must never carry award/person data. */
export const TelemetryPage = z.enum([
  'home',
  'insights',
  'insights_team',
  'my_rewards',
  'recognize',
  'awards',
  'queue',
  'approvals',
  'executive',
  'admin',
  'settings',
  'help',
  'auth',
  'other',
]);
export type TelemetryPage = z.infer<typeof TelemetryPage>;
export const BrowserDiagnostic = z
  .object({
    event: z.enum([
      'route_error',
      'route_not_found',
      'window_error',
      'unhandled_rejection',
      'react_error',
      'api_error',
      'api_attempt_error',
    ]),
    page: TelemetryPage,
    diagnostic: z.enum([
      'not_found',
      'access_denied',
      'network_error',
      'invalid_response',
      'http_error',
      'runtime_error',
    ]),
    status: z.number().int().min(0).max(599).optional(),
    requestId: z.uuid().optional(),
  })
  .strict();
export type BrowserDiagnostic = z.infer<typeof BrowserDiagnostic>;

export function telemetryPage(path: string): TelemetryPage {
  const pathname = path.split(/[?#]/, 1)[0] ?? '';
  if (pathname === '/') return 'home';
  if (pathname === '/insights/team' || pathname.startsWith('/insights/team/'))
    return 'insights_team';
  const area = pathname.split('/')[1];
  if (area === 'my-rewards' || area === 'letters-to-hand-out') return 'my_rewards';
  if (area === 'sign-in' || area === 'welcome' || area === 'no-access' || area === 'auth')
    return 'auth';
  const known = TelemetryPage.safeParse(area);
  return known.success ? known.data : 'other';
}
